<template>
    <div if="applicant-supplier-onboarding" class="vx-row no-gutter justify-center pt-16">
        <div v-if="isMounted" class="vx-col sm:w-5/6 md:w-2/3 lg:w-1/2 xl:w-1/2 xxl:w-1/2 m-0">
            <vx-card v-if="loanData.onboarding_step != '2_accept_third_party_review'" class="login-card py-6 px-12">
                <div slot="no-body" class="">
                    <div class="vx-col sm:w-full">
                        <div class="login-tabs-container">
                            <div class="vx-row m-0">
                                <div class="vx-col w-full p-0" style="min-height: 200px">
                                    <div class="pt-5 pb-5">
                                        <!-- 1_activate_account -->
                                        <div v-if="loanData.onboarding_step == null" class="vx-row mb-4">
                                            <div v-if="hasConfirmPersonalInformation">
                                                <div class="vx-col w-full mb-4">
                                                    <p class="text-4xl card-sub-title text-center mb-base">Activa tu cuenta.
                                                    </p>
                                                    <div v-html="supplierDescription" id="has-supplier" class="referral-code mt-4 mb-base m-16"
                                                        style="background-color: #A7F805;">
                                                    </div>
                                                    <h3 class="text-1xl">Podrás ingresar a tu cuenta con este correo
                                                        como
                                                        usuario:</h3>
                                                    <p class="text-1xl  mb-4 text-lg">
                                                        {{ loanData.applicant_email }}
                                                    </p>
                                                </div>
                                                <div class="vx-col w-full mb-4">
                                                    <h3 class="text-1xl">Crea tu contraseña</h3>
                                                </div>
                                                <div class="vx-col mb-4 sm:w-full md:w-1/2 lg:w-1/2">
                                                    <div :class="colClass">
                                                        <label class="vs-input--label">Contraseña *</label>
                                                        <vx-input-group class="w-full">
                                                            <vs-input v-model.lazy="onboardingUserData.password"
                                                                v-validate="requiredRules"
                                                                :danger="hasError('password')"
                                                                :danger-text="errorText('password')"
                                                                :success="passwordFieldValid" :type="passInputType"
                                                                :placeholder="requiredPlaceholder" name="password" />

                                                            <template slot="append">
                                                                <div class="append-text btn-addon" style="height:40px;">
                                                                    <vs-button color="dark"
                                                                        @click="togglePassInputType()"
                                                                        icon-pack="feather"
                                                                        :icon="passInputIcon"></vs-button>
                                                                </div>
                                                            </template>
                                                        </vx-input-group>
                                                    </div>
                                                    <div v-if="onboardingUserData.password != null && onboardingUserData.password != ''"
                                                        :class="colClass">
                                                        <div class="vx-row">
                                                            <div class="vx-col md:w-1/2 sm:w-full w-full">
                                                                <p>
                                                                    <feather-icon
                                                                        :svgClasses="`${colorForCriteria(0)} h-4 w-4`"
                                                                        class="p-2" :icon="iconForCriteria(0)" />Una
                                                                    letra
                                                                    minúscula <br>
                                                                    <feather-icon
                                                                        :svgClasses="`${colorForCriteria(1)} h-4 w-4`"
                                                                        class="p-2" :icon="iconForCriteria(1)" />Una
                                                                    letra
                                                                    mayúscula <br>
                                                                    <feather-icon
                                                                        :svgClasses="`${colorForCriteria(2)} h-4 w-4`"
                                                                        class="p-2" :icon="iconForCriteria(2)" />Un
                                                                    número
                                                                    <br>
                                                                    <feather-icon
                                                                        :svgClasses="`${colorForCriteria(3)} h-4 w-4`"
                                                                        class="p-2" :icon="iconForCriteria(3)" />Un
                                                                    símbolo
                                                                    <br>
                                                                </p>
                                                            </div>
                                                            <div class="vx-col md:w-1/2 sm:w-full w-full">
                                                                <p>
                                                                    <feather-icon
                                                                        :svgClasses="`${colorForCriteria(4)} h-4 w-4`"
                                                                        class="p-2" :icon="iconForCriteria(4)" />8
                                                                    caracteres
                                                                    mínimo <br>
                                                                    <feather-icon
                                                                        :svgClasses="`${colorForCriteria(5)} h-4 w-4`"
                                                                        class="p-2" :icon="iconForCriteria(5)" />Sin
                                                                    letras
                                                                    ni
                                                                    números consecutivos <br>
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div :class="colClass">
                                                        <label class="vs-input--label">Confirma la contraseña *</label>
                                                        <vx-input-group class="w-full">
                                                            <vs-input onpaste="return false;"
                                                                v-model.lazy="onboardingUserData.confirmed_password"
                                                                v-validate="requiredRules"
                                                                :danger="hasError('confirmed_password')"
                                                                :danger-text="errorText('confirmed_password')"
                                                                :success="confirmPasswordFieldValid"
                                                                :type="confirmPassInputType"
                                                                :placeholder="requiredPlaceholder"
                                                                name="confirmed_password" />
                                                            <template slot="append">
                                                                <div class="append-text btn-addon" style="height:40px;">
                                                                    <vs-button color="dark"
                                                                        @click="toggleConfirmPassInputType()"
                                                                        icon-pack="feather"
                                                                        :icon="confirmPassInputIcon"></vs-button>
                                                                </div>
                                                            </template>
                                                        </vx-input-group>
                                                    </div>
                                                    <vs-alert v-if="errorMssg" icon-pack="feather"
                                                        icon="icon-alert-triangle" class="mb-5" color="danger">
                                                        <span class="font-regular">{{ errorMssg }}</span>
                                                    </vs-alert>
                                                </div>
                                                <div class="vx-col w-full mb-4">
                                                    <div :class="colClass">
                                                        <p>
                                                            Al dar click en "Activar cuenta", aceptas los <a
                                                                class="bold" target="_blank" rel="noopener"
                                                                :href="$sanitizeUrl(terminosCondicionesUrl)"> Términos y
                                                                Condiciones</a>, el <a class="bold" target="_blank"
                                                                rel="noopener"
                                                                :href="$sanitizeUrl(avisoPrivacidadUrl)">Aviso de
                                                                Privacidad</a> y el <a class="bold"
                                                                :href="$sanitizeUrl(avisoPrivacidadUrl)" target="_blank"
                                                                rel="noopener noreferrer">Contrato Comisión
                                                                Mercantil</a> de
                                                            RedGirasol.
                                                        </p>
                                                    </div>
                                                </div>
                                                <div class="vx-col sm:w-1/3 md:1/4 lg:1/6">
                                                    <vs-button @click.stop="activateAccount" class="w-full">Activar
                                                        cuenta</vs-button>
                                                </div>
                                            </div>
                                            <div v-else>
                                                    <p class="text-4xl card-sub-title text-center mb-base">
                                                        Activa tu cuenta.
                                                    </p>
                                                    <div v-html="supplierDescription" id="has-supplier" class="referral-code mt-4 mb-base m-16"
                                                        style="background-color: #A7F805;">
                                                    </div>
                                                    <div class="flex justify-center">
                                                        <ApplicantOnboardingCheckData
                                                            v-if="isMounted"
                                                            :onboarding-step-data="loanData"
                                                            :isFromThirdParty="true"
                                                            @updated="hasConfirmPersonalInformation = true"/>
                                                    </div>
                                            </div>
                                        </div>
                                        <!-- 2_accept_third_party_review -->
                                        <div v-else-if="loanData.onboarding_step == '1_activate_account'">
                                            <div>
                                                <div v-html="supplierDescription" id="has-supplier" class="referral-code mt-4 mb-base m-16"
                                                    style="background-color: #A7F805;"></div>
                                                <h3 class="text-1xl mb-4">Autorización para tu instalador</h3>
                                                <p class="text-1xl  mb-base text-lg">
                                                    ¿Aceptas a tu instalador como <span
                                                        @click="showThirdPartyContractPopup = true"
                                                        class="clickable-img"><u>tercero autorizado</u></span> <span
                                                        class="bold">{{ supplierName }} </span>
                                                    para que complete la solicitud de
                                                    crédito a tu nombre?
                                                </p>
                                                <div class="vx-row">
                                                    <div class="vx-col sm:w-1/2 md:w-1/3 lg:w-1/3 mb-4">
                                                        <vs-button @click.stop="acceptThirdParty()"
                                                            class="w-full">Aceptar</vs-button>
                                                    </div>
                                                </div>
                                                <div class="vx-row">
                                                    <div class="vx-col sm:w-1/2 md:w-1/3 lg:w-1/3">
                                                        <div @click.stop="isNotAuthorizePopupActive = true"
                                                            class="clickable-img">
                                                            <span class="black">
                                                                <u>
                                                                    No aceptar
                                                                </u>
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-else-if="loanData.onboarding_step == '3_cdc_query_success'">
                                            <div v-if="!isMoral" class="vx-col sm:w-full">
                                                <div class="login-tabs-container">
                                                    <div class="vx-row m-0">
                                                        <div class="vx-col w-full p-0" style="min-height: 200px">
                                                            <!-- MAIN-DIV -->
                                                            <div class="p-10">
                                                                <!-- HEADER -->
                                                                <div class="vx-row mb-2">
                                                                    <div class="vx-col w-full align-center">
                                                                        <p class="text-4xl card-sub-title">Verificación
                                                                            de identidad.</p>
                                                                    </div>
                                                                </div>
                                                                <!-- CONTENT -->
                                                                <div class="vx-row">
                                                                    <div class="vx-col w-full mb-base card-img">
                                                                        <img :src="identityCardURL"
                                                                            alt="Verificación de identidad RG">
                                                                    </div>
                                                                    <div class="vx-col w-full">
                                                                        <div class="vx-row justify-between">
                                                                            <div class="text-sm vx-col w-full mb-4">
                                                                                <p>Comprobemos que eres tú. Te
                                                                                    compartimos algunas sugerencias para
                                                                                    la
                                                                                    verificación:</p>
                                                                            </div>
                                                                            <div
                                                                                class="text-sm vx-col sm:w-full md:w-1/2 mb-4">
                                                                                <ul class="ul-disc ml-4">
                                                                                    <li>Ingresa desde un dispositivo con
                                                                                        cámara</li>
                                                                                    <li>Hazlo en un lugar iluminado</li>
                                                                                    <li>Ten a la mano tu identificación
                                                                                        oficial</li>
                                                                                </ul>
                                                                            </div>
                                                                            <div
                                                                                class="align-center md:w-1/2 mt-2 sm:w-full vx-col">
                                                                                <vs-button class="w-3/5"
                                                                                    @click.stop="openMatiPopup">Comenzar</vs-button>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-else>
                                                <GuaranteeOnboardingSyntagePage
                                                    :guarantee="loanData.user"
                                                    :isFromGuarantee="false"
                                                />
                                            </div>
                                        </div>
                                        <div v-else-if="loanData.onboarding_step == '4_identity_verification_success'">
                                            <h2 class="mb-4">¡Gracias por completar tu proceso de onboarding de crédito!</h2>
                                            <p class="black">
                                                Hemos recibido toda la información necesaria y tu solicitud ya se encuentra en revisión por parte del equipo de Riesgo de RedGirasol.
                                                <br>
                                                <br>
                                                Por el momento, solo queda esperar mientras realizan el análisis correspondiente. En cuanto tengan una resolución o requieran información adicional, se pondrán en contacto contigo.
                                                <br>
                                                <br>
                                                <span class="bold">¡Gracias por tu confianza y por dar este paso con nosotros!</span>
                                            </p>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </vx-card>
            <!-- REVISIÓN CDC -->
            <div v-else>
                <GuaranteeOnboardingCDCRequest
                    v-if="!isMoral"
                    :guarantee="loanData.user" 
                    :isFromGuarantee="false" />

                <GuaranteeOnboardingBusinessCDC 
                    v-else
                    :guarantee="loanData.user"
                    :isFromGuarantee="false"
                />
                
            </div>
        </div>

        <!-- CARTA DE AUTERIZACIÓN -->
        <vs-popup v-if="isMounted" :active.sync="showThirdPartyContractPopup" title="DESIGNACIÓN DE TERCERO AUTORIZADO">
            <ThirdPartyContract :applicant="loanData.applicant_name" :supplier="`${supplierName}`" />
        </vs-popup>
        <!-- NO AUTORIZO AL PROVEEDOR -->
        <vs-popup v-if="isMounted" :active.sync="isNotAuthorizePopupActive"
            :title="`No autorizar al instalador ${loanData.supplier_tradename}`" :close-on-click-outside="false">
            <div class="px-4 pb-4">
                <p class="text-lg mb-base">
                    ¿Estás seguro de que no deseas autorizar al instalador {{ loanData.supplier_tradename }} para que
                    continúe con
                    tu solicitud de crédito?
                    <br><br>
                    Si no autorizas al instalador, podrás crear la solicitud tú mismo o solicitar a otro instalador
                    que lo
                    haga por ti.
                </p>
                <div class="vx-row">
                    <div class="vx-col sm:w-1/2 md:w-1/3 lg:w-1/3">
                        <vs-button class="w-full" @click="isNotAuthorizePopupActive = false">Cancelar</vs-button>
                    </div>
                    <div class="vx-col sm:w-1/2 md:w-1/3 lg:w-1/3">
                        <vs-button type="border" class="w-full"
                            @click="isNotAuthorizePopupActive = false, isContinuePopupActive = true">No
                            autorizar</vs-button>
                    </div>
                </div>
            </div>
        </vs-popup>

        <!-- Continuar con la solicitud -->
        <vs-popup v-if="isMounted" :active.sync="isContinuePopupActive" title="¿Aún deseas solicitar un crédito solar?"
            :close-on-click-outside="false">
            <div class="px-4 pb-4">
                <p class="text-lg mb-base">
                    Podrás continuar con tu solicitud desde tu portal de solicitante.
                </p>
                <div class="vx-row">
                    <div class="vx-col sm:w-1/2 md:w-5/12 lg:w-5/12">
                        <vs-button class="w-full pl-2 pr-2" @click="cancelLoanRequest(1)">Continuar con mi
                            solicitud</vs-button>
                    </div>
                    <div class="vx-col sm:w-1/2 md:w-5/12 lg:w-5/12">
                        <vs-button type="border" class="w-full"
                            @click="isCanceling = true, isContinuePopupActive = false">Cancelar solicitud</vs-button>
                    </div>
                </div>
            </div>
        </vs-popup>

        <!-- Cancelar crédito -->
        <vs-popup id="cancel-credit-popup" v-if="isMounted" :active.sync="isCanceling" title="Cancelar solicitud?"
            :close-on-click-outside="false">
            <div class="px-4 pb-4">
                <p class="text-lg mb-base">
                    ¿Estás seguro de que deseas cancelar tu solicitud? Perderás tu avance y tendrás que comenzar de
                    nuevo si
                    deseas solicitar el crédito.
                </p>
                <div class="vx-row">
                    <div class="vx-col sm:w-1/2 md:w-5/12 lg:w-5/12">
                        <vs-button class="w-full" @click="isCanceling = false">Regresar</vs-button>
                    </div>
                    <div class="vx-col sm:w-1/2 md:w-5/12 lg:w-5/12">
                        <vs-button type="border" color="danger" class="w-full pl-2 pr-2"
                            @click="cancelLoanRequest(0)">Cancelar
                            solicitud</vs-button>
                    </div>
                </div>
            </div>
        </vs-popup>
        <!-- MATI -->
        <mati-popup 
            v-if="isMounted" 
            :user-id-to-activate="loanData.user_id"
            :citizenship="'700'"
            @on-mati-process-started="onMatiProcessStarted" 
            @finished="onMatiProcessFinished" />
    </div>
</template>

<script>
import GuaranteeOnboardingCDCRequest from '../loan-requests/guarantee-onboarding/components/GuaranteeOnboardingCDCRequest.vue';
import GuaranteeOnboardingIdentifiers from '../loan-requests/guarantee-onboarding/components/GuaranteeOnboardingIdentifiers.vue';
import MatiPopup from "@components/mati/MatiPopup";
import ThirdPartyContract from '../contracts/ThirdPartyContract.vue';
import ApplicantOnboardingCheckData from '@views/applicant/onboarding/components/ApplicantOnboardingCheckData.vue';
import GuaranteeOnboardingBusinessCDC from '../loan-requests/guarantee-onboarding/components/business/GuaranteeOnboardingBusinessCDC.vue';
import GuaranteeOnboardingSyntagePage from '../loan-requests/guarantee-onboarding/components/business/GuaranteeOnboardingSyntagePage.vue';

const textType = "text";
const iconEye = "icon-eye";
const iconEyeOff = "icon-eye-off";

const requiredObjects = [
    'user.personal.address',
    'user.personal.phone',
    'user.business.personal',
    'user.business.personal.phone',
    'user.business.address',
    'user.business.phone',
];


export default {
    name: "ApplicantSupplierOnboardingStepPage",
    props: {
        token: String,
        loan_id: String,
    },
    components: {
        GuaranteeOnboardingCDCRequest,
        GuaranteeOnboardingIdentifiers,
        MatiPopup,
        ThirdPartyContract,
        ApplicantOnboardingCheckData,
        GuaranteeOnboardingBusinessCDC,
        GuaranteeOnboardingSyntagePage
    },
    data: () => ({
        loanData: null,
        hasLoan: false,
        colClass: "vx-col sm:w-full mb-5",
        requiredRules: 'required',
        requiredPlaceholder: '(Requerido)',
        errorMssg: null,
        isMounted: false,
        passInputPassMode: true,
        confirmPassInputPassMode: true,
        criteria: [false, false, false, false, false, false, false],
        passwordError: null,
        onboardingUserData: {
            alias: null,
            email: null,
            password: null,
            confirmed_password: null,
            source: null,
            other_source: null,
            check_legal: false,
            preauth: null
        },
        isNotAuthorizePopupActive: false,
        isContinuePopupActive: false,
        isSelectingHowtoContinue: false,
        isCanceling: false,
        showThirdPartyContractPopup: false,
        hasConfirmPersonalInformation: false,
    }),
    async mounted() {
        this.showLoading(true, "Cargando información...");
        await this.checkApplicantData();
        this.isMounted = true;
        this.showLoading(false);
    },
    computed: {
        isMoral() {
            return !this.loanData.is_physical_person;
        },
        terminosCondicionesUrl() {
            return 'https://www.redgirasol.com/terminos-y-condiciones';
        },
        avisoPrivacidadUrl() {
            return 'https://www.redgirasol.com/aviso-de-privacidad';
        },
        passInputType() {
            return this.passInputPassMode ? "password" : textType;
        },
        passInputIcon() {
            return this.passInputPassMode ? iconEye : iconEyeOff;
        },
        confirmPassInputType() {
            return this.confirmPassInputPassMode ? "password" : textType;
        },
        confirmPassInputIcon() {
            return this.confirmPassInputPassMode ? iconEye : iconEyeOff;
        },
        passwordFieldValid() {
            return this.testPassword(this.onboardingUserData.password);
        },
        confirmPasswordFieldValid() {
            return this.onboardingUserData.password === this.onboardingUserData.confirmed_password && this.onboardingUserData.confirmed_password != null;
        },
        identityCardURL() {
            return `${this.StorageURL}/applicants/guarantees-onboarding/identity-card-icon.png`;
        },
        supplierName() {
            return `${this.loanData.supplier_tradename} - ${this.loanData.supplier_fiscal_name}`;
        },
        supplierDescription() {
            return `<span class="bold">${this.loanData.supplier_tradename}</span> ha
                    creado una pre-solicitud de crédito para ti. Crea tu cuenta y
                    autoriza a tu instalador para continuar con la solicitud.`
        }
    },
    methods: {
        async checkApplicantData() {
            try {
                const res = await this.publicApiGet(`/api/v2/applicantOnboarding/${this.loan_id}/check-token/${this.token}`);

                const loan = res.data.loan;
                this.hasLoan = loan !== null;

                if (!this.hasLoan) {
                    await this.$router.push({ name: 'notFound' });
                }

                this.loanData = loan;

                this.onboardingUserData.preauth = this.token;
            } catch (error) {
                console.log(error);
                await this.$router.push({ name: 'notFound' });
            }
        },
        async activateAccount() {

            this.errorMssg = null;
            if (!await this.validateForm()) {
                return;
            }

            this.onboardingUserData.check_legal = true;

            try {
                console.log("Activating account with data:", this.onboardingUserData);
                this.showLoading(true, "Activando cuenta...");
                const res = await this.publicApiPost(`/api/v2/applicantOnboarding/activate-account`, {
                    user: this.onboardingUserData,
                    loan_id: this.loanData.id,
                });

                await this.checkApplicantData();
                this.$vs.notify({
                    title: 'Éxito',
                    text: 'La cuenta ha sido activada exitosamente.',
                    color: 'success',
                    position: 'top-right'
                });
            } catch (e) {
                this.showError(e);
                this.showLoading(false);
            } finally {
                this.showLoading(false);
            }
        },
        async acceptThirdParty() {
            try {
                this.showLoading(true, "Aplicando autorización...");
                const res = await this.publicApiPost(`/api/v2/applicantOnboarding/accept-third-party`, {
                    user: this.onboardingUserData,
                    loan_id: this.loanData.id,
                });
                await this.checkApplicantData();
                this.$vs.notify({
                    title: 'Éxito',
                    text: 'Haz autorizado a tu instalador correctamente.',
                    color: 'success',
                    position: 'top-right'
                });
            } catch (error) {
                this.showLoading(false);
                console.error(error);
                this.failedOperationNotif();
            } finally {
                this.showLoading(false);
            }
        },
        async cancelLoanRequest(canContinue) {
            try {
                this.showLoading(true, "Cancelando solicitud...");
                const res = await this.publicApiPost(`/api/v2/applicantOnboarding/cancel-account`, {
                    user: this.onboardingUserData,
                    loan_id: this.loanData.id,
                    can_continue: canContinue
                });

                this.showLoading(false);
                this.saveSuccessNotif();
                this.isCanceling = false;

                if (canContinue) {
                    if (this.onboardingUserData.password != null) {
                        await this.doLogin();
                    } else {
                        await this.goToLogin();
                    }
                }

            } catch (error) {
                this.showLoading(false);
                console.error(error);
                this.failedOperationNotif();
            } finally {
                this.showLoading(false);
            }
        },
        hasError(val) {
            return this.errors.has(val);
        },
        errorText(val) {
            return this.errors.first(val);
        },
        isSuccess(val) {
            let ff = this.fields[val];
            return (ff && ff.required && ff.valid);
        },
        togglePassInputType() {
            this.passInputPassMode = !this.passInputPassMode;
        },
        toggleConfirmPassInputType() {
            this.confirmPassInputPassMode = !this.confirmPassInputPassMode;
        },
        testPassword(pass) {
            if (pass === null || pass === undefined) {
                this.criteria[0] = false;
                this.criteria[1] = false;
                this.criteria[2] = false;
                this.criteria[3] = false;
                this.criteria[4] = false;
                this.criteria[5] = false;
                this.criteria[6] = false;
                return false;
            }
            //let pass = this.pw1
            const number = /.*[0-9].*/
            const lower = /.*[a-z].*/
            const upper = /.*[A-Z].*/
            const special = /.*[!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~].*/
            const consecutive = ['abcd', 'bcde', 'cdef', 'defg', 'efgh', 'fghi', 'ghij', 'hijk', 'ijkl', 'jklm', 'klmn', 'lmnñ', 'mnño', 'nñop', 'ñopq', 'opqr', 'pqrs', 'qrst', 'rstu', 'stuv', 'tuvw', 'uvwx', 'vwxy', 'wxyz',
                '0123', '1234', '2345', '3456', '4567', '5678', '6789', '7890', '8901', '9012', '2109', '1098', '0987', '9876', '8765', '7654', '6543', '5432', '4321', '3210',
                'aaaa', 'bbbb', 'cccc', 'dddd', 'eeee', 'ffff', 'gggg', 'hhhh', 'iiii', 'jjjj', 'kkkk', 'llll', 'mmmm', 'nnnn', 'ññññ', 'oooo', 'pppp', 'qqqq', 'rrrr', 'ssss', 'tttt', 'uuuu', 'vvvv', 'wwww', 'xxxx', 'yyyy', 'zzzz',
                '1111', '2222', '3333', '5555', '6666', '7777', '8888', '9999',
                '!!!!', '""""', '####', '$$$$', '%%%%', '&&&&', '((((', '))))', '****', '++++', ',,,,', '----', '....', '////', '::::', ';;;;', '<<<<', '====', '>>>>',
                '????', '@@@@', '[[[[', ']]]]', '^^^^', '____', '````', '{{{{', '||||', '}}}}', '~~~~']

            this.criteria[0] = lower.test(pass);
            this.criteria[1] = upper.test(pass);
            this.criteria[2] = number.test(pass);
            this.criteria[3] = special.test(pass);
            this.criteria[4] = pass.length > 7;
            let no_consecutive = true
            for (let i = 0; i < consecutive.length; i++) {
                if (pass.toLowerCase().includes(consecutive[i])) {
                    no_consecutive = false
                }
            }
            this.criteria[5] = no_consecutive

            return (this.criteria[0] && this.criteria[1] && this.criteria[2] && this.criteria[3] && this.criteria[4] && this.criteria[5]);
        },
        async validateForm() {
            this.errorMssg = null;
            let r1 = await this.$validator.validateAll();
            if (r1) {
                return this.validatePassword();
            }
            return false;
        },
        colorForCriteria(idx) {
            return this.criteria[idx] ? 'text-success' : 'text-danger';
        },
        iconForCriteria(idx) {
            return this.criteria[idx] ? 'CheckCircleIcon' : 'CircleIcon';
        },
        completePasswordForm() {
            return this.onboardingUserData.password != null && this.onboardingUserData.password.length >= 8;
        },
        completeConfirmPassword() {
            return this.onboardingUserData.confirmed_password != null && this.onboardingUserData.confirmed_password.length >= 8;
        },
        validatePassword() {
            if (this.onboardingUserData.password !== this.onboardingUserData.confirmed_password) {
                this.errorMssg = "Las contraseñas no coinciden";
            }
            else {
                if (this.testPassword(this.onboardingUserData.password)) {
                    return true;
                }
                else {
                    this.errorMssg = "La contraseña no cumple los requerimientos";
                }
            }
            return false;
        },
        async goToLogin() {
            this.isContinuePopupActive = false;
            await this.$router.replace({ name: 'login' });
        },
        async onMatiProcessStarted() {
            this.$store.commit("SET_MATI_PROCESS_IS_RUNNING", true);
            this.$store.commit("TOGGLE_IS_MATI_POPUP_ACTIVE", false);
        },
        async openMatiPopup() {
            this.$store.commit("SET_MATI_PROCESS_IS_RUNNING", true);
            this.$store.commit("TOGGLE_IS_MATI_POPUP_ACTIVE", true);
        },
        async onMatiProcessFinished() {
            try {
                window.location.reload();
                // await this.checkApplicantData();
            } catch (error) {
                this.failedOperationNotif();
                console.log(error);
            }
        }
    }
}
</script>

<style>
#cancel-credit-popup .vs-popup--header {
    background-color: #f2f2f2;
    color: #EA5455 !important;
}

#cancel-credit-popup .vs-popup--title h3 {
    color: #EA5455 !important;
}

.vs-popup--header {
    background-color: #28DE18;
    color: #fff !important
}

.vs-popup--title h3 {
    color: #fff !important
}

.card-img {
    text-align: center;
    text-align: -webkit-center;
}

.card-img img {
    width: 100%;
    max-width: 350px;
}
</style>